import React, { useState, useEffect } from "react";
import axios from "axios";

import Movie from "./Movie";
import classes from "./Movies.module.css";

const Search = props => {
  const { keyword, searchRef } = props;
  const [results, setResults] = useState([]);
  const [error, setError] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      axios
        .get(
          `https://api.themoviedb.org/3/search/movie?api_key=d527b80849d55bcff1111f0777f4e175&language=tr-TR&query=${keyword}`
        )
        .then(res => {
          const val = res.data.results;
          const loadedData = [];
          val.forEach(data => {
            if (data.poster_path !== null) {
              loadedData.push({
                id: data.id,
                name: data.original_title,
                nameTR: data.title,
                image: data.poster_path,
                info: data.overview,
                date: data.release_date
              });
            }
          });
          setResults(loadedData);
        }).catch(err => {
          console.log(err);
          setError(true);
        });
    }, 500);
  }, [keyword, searchRef]);

  let content = <div className={classes.Movies}>Yükleniyor...</div>;
  if (results) {
    content = results.map(val => (
      <Movie
        key={val.id}
        id={val.id}
        name={val.name}
        nameTR={val.nameTR}
        image={val.image}
        info={val.info}
        date={val.date}
      />
    ));
  }
  if(error) {
    return <div className={classes.Movies}>Bir şeyler ters gitti!</div>;
  }

  return <div className={classes.Movies}>{content}</div>;
};

export default Search;
